import { post } from "../../api";

const fetchBrandsList = () => post("brandListNew");

export default fetchBrandsList;
